<template>
  <div class="sidebar-nav lms-nav">
    <div @click="$emit('toggle-nav')" class="lms-nav-toggler" role="button">
      <feather :type="expanded ? 'chevron-left' : 'chevron-right'"></feather>
    </div>
    <div class="pd-t-20 pd-x-10 box-list">
      <label class="box-list-divider">
        <feather type="folder" class="mg-l-5 mg-t-5 tx-color-04"></feather>
        <span>Тухай</span>
      </label>
      <div
        @click="navhome()"
        class="media"
        :class="{ active: 0 == $route.params.bid }"
      >
        <div class="avatar avatar-sm">
          <span
            :class="
              `avatar-initial rounded-circle bd ${
                isCompleted
                  ? 'bg-success bd-success'
                  : 'bg-transparent bd-gray-900'
              }`
            "
          >
            <feather
              v-if="isCompleted"
              type="check-square"
              class="text-white"
              :size="16"
            ></feather>
            <feather v-else type="home" class="tx-inverse" :size="16"></feather>
          </span>
        </div>
        <div class="media-body mg-l-10">
          <h6 class="tx-13 mg-b-3">{{ title }}</h6>
          <span class="tx-12"></span>
        </div>
      </div>
    </div>
    <vue-custom-scrollbar style="height: calc(100vh - 231px);">
      <div
        class="pd-t-20 pd-x-10 box-list"
        v-for="(b, i) in boxes"
        :key="i"
        :class="{ active: $route.params.iid == 0 && b.id == $route.params.bid }"
      >
        <label
          @click="navopen(b)"
          v-if="b.tasks.length || b.attaches.length || b.forms.length"
          class="box-list-divider"
        >
          <feather type="folder" class="mg-l-5 mg-t-5 tx-color-04"></feather>
          <span>{{ b.nm }}</span>
          <!-- {{b.ot}} -->
        </label>
        <section v-if="b.tasks.length">
          <div
            @click="subNavOpen(b, t)"
            class="media"
            v-for="(t, i) in b.tasks"
            :key="i"
            :class="{ active: t.id == $route.params.iid }"
          >
            <div class="avatar avatar-sm">
              <span
                :class="
                  `avatar-initial rounded-circle bd ${getTaskIconBg(b, t)}`
                "
              >
                <feather
                  v-if="t.isCompleted"
                  type="check-square"
                  class="text-white"
                  :size="16"
                ></feather>
                <feather
                  v-else
                  :type="getTaskIcon(b, t)"
                  class="tx-inverse"
                  :size="16"
                ></feather>
              </span>
            </div>
            <div class="media-body mg-l-10">
              <h6 class="tx-13 mg-b-3">{{ t.task }}</h6>
              <span class="tx-12"></span>
            </div>
          </div>
        </section>
        <section v-else-if="b.attaches.length">
          <div
            @click="subNavOpen(b, a)"
            class="media"
            v-for="(a, i) in b.attaches"
            :key="i"
            :class="{ active: a.id == $route.params.iid }"
          >
            <div class="avatar avatar-sm">
              <span
                :class="
                  `avatar-initial rounded-circle ${
                    a.isCompleted
                      ? 'bg-success bd-success bd'
                      : 'bg-transparent bd bd-gray-900'
                  }`
                "
              >
                <i
                  v-if="!a.isCompleted"
                  :class="
                    `far fa-file-${getFileIcon(a)} ${getFileIcon(
                      a
                    )} tx-16 tx-color-03 tx-${getTextColor(a)}`
                  "
                ></i>
                <feather
                  v-else
                  type="check-square"
                  class="text-white"
                  :size="16"
                ></feather>
                <!-- <feather :type="getFileIcon(a)" :size="16" class="tx-inverse"></feather> -->
              </span>
            </div>
            <div class="media-body mg-l-10 mx-wd-80p">
              <h6 class="tx-13 mg-b-3 overflow-hidden">
                {{ a.t != "" ? a.t : a.n }}
              </h6>
              <div class="d-flex">
                <span class="tx-12">{{ getSize(a.s) }}</span>
                <span
                  class="tx-12 mg-l-auto"
                  v-show="a.dur != undefined && a.dur != null"
                  >{{ a.dur }} мин</span
                >
              </div>
            </div>
          </div>
        </section>
        <section v-else-if="b.forms.length">
          <div
            @click="subNavOpen(b, f)"
            class="media"
            v-for="(f, i) in b.forms"
            :key="i"
            :class="{ active: f.id == $route.params.iid }"
          >
            <div class="avatar avatar-sm">
              <span
                class="avatar-initial rounded-circle bg-transparent bd bd-gray-900"
              >
                <feather
                  type="pen-tool"
                  class="tx-inverse"
                  :size="16"
                ></feather>
              </span>
            </div>
            <div class="media-body mg-l-10">
              <h6 class="tx-13 mg-b-3">{{ f.nm }}</h6>
              <div class="progress ht-5 mg-b-5" v-if="f.flag == 800">
                <div
                  role="progressbar"
                  :class="`progress-bar bg-${calcaulateProgressBg(f)}`"
                  :style="{ width: calcaulateProgress(f) + '%' }"
                >
                  <!-- <span class="tx-9">{{(calcaulateProgress(f)).toFixed(2)}}%</span> -->
                </div>
              </div>
              <span
                class="tx-12"
                :title="
                  `Бөглөсөн ${f.fillingCount} / Нийт асуулт ${f.qCount} / (Боломжит оролдлого ${f.attemptCount} - Бүрэн дуусгасан ${f.resultCount})`
                "
                >{{ f.fillingCount }} / {{ f.qCount }} / ({{ f.attemptCount }} -
                {{ f.resultCount }})</span
              >
            </div>
          </div>
        </section>
      </div>
    </vue-custom-scrollbar>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import { getSize, getFileIcon } from "@/libs/tools";

export default {
  components: {
    vueCustomScrollbar
  },
  props: {
    title: {
      type: String,
      default: () => ""
    },
    isCompleted: {
      type: Boolean,
      default: () => false
    },
    boxes: {
      type: Array,
      default: () => []
    },
    expanded: {
      type: Boolean,
      default: () => true
    }
  },
  mounted() {},
  methods: {
    prevOrNextContent(e) {
      //console.log('prevOrNextContent', e);
      if (e.mode == 0) {
        this.navopen(this.boxes[0]);
      } else {
        let _b = this.boxes.filter(x => x.id == e.params.bid);

        if (_b.length) {
          let boxOption = "";

          if (e.params.iid > 0) {
            if (_b[0].attaches.length) {
              boxOption = "attaches";
            } else if (_b[0].forms.length) {
              boxOption = "forms";
            } else if (_b[0].tasks.length) {
              boxOption = "tasks";
            }

            //console.log('boxOption=> ', boxOption);

            //let ind= _b[0][boxOption].map(a=> { return a.id }).indexOf(e.params.iid);
            let ind = _b[0][boxOption].findIndex(x => x.id === e.params.iid);
            let indBox = this.boxes
              .map(b => {
                return b.id;
              })
              .indexOf(e.params.bid);
            if (ind == 0 && e.mode == -1) {
              this.navopen(_b[0]);
            } else if (ind == _b[0][boxOption].length - 1 && e.mode == 1) {
              //console.log('end bnuu');
              if (indBox + 1 == this.boxes.length)
                this.$emit("on-show-next-lesson");
              else this.navopen(this.boxes[indBox + e.mode]);
            } else {
              let _item = _b[0][boxOption][ind + e.mode];
              //console.log('-----------------------------------------za end bndaa--------------------------------------', e.params.iid, ind, e.mode, _item.task);
              this.subNavOpen(_b[0], _item);
            }
          } else if (e.params.iid == 0 && e.params.bid > 0 && e.mode == -1) {
            let indBox = this.boxes
              .map(b => {
                return b.id;
              })
              .indexOf(e.params.bid);
            if (indBox > 0) {
              if (this.boxes[indBox - 1].attaches.length) {
                boxOption = "attaches";
              } else if (this.boxes[indBox - 1].forms.length) {
                boxOption = "forms";
              } else if (this.boxes[indBox - 1].tasks.length) {
                boxOption = "tasks";
              }

              if (this.boxes[indBox + e.mode][boxOption].length) {
                let _item = {};
                _item = this.boxes[indBox + e.mode][boxOption][
                  this.boxes[indBox + e.mode][boxOption].length - 1
                ];
                this.subNavOpen(this.boxes[indBox + e.mode], _item);
              } else {
                this.navopen(this.boxes[indBox + e.mode]);
              }
            } else {
              this.navhome();
            }
          } else if (e.params.iid == 0 && e.params.bid > 0 && e.mode == 1) {
            if (_b[0].attaches.length) {
              boxOption = "attaches";
            } else if (_b[0].forms.length) {
              boxOption = "forms";
            } else if (_b[0].tasks.length) {
              boxOption = "tasks";
            }
            if (boxOption != "") {
              if (_b[0][boxOption].length) {
                this.subNavOpen(_b[0], _b[0][boxOption][0]);
              }
            } else {
              let indBox = this.boxes
                .map(b => {
                  return b.id;
                })
                .indexOf(e.params.bid);
              this.subNavOpen(this.boxes[indBox + e.mode]);
            }
          }
        }
      }
      //console.log('prevOrNextContent=> ', e);
    },
    navhome() {
      this.$router.push({
        name: "lmsLessonView",
        params: {
          id: this.$route.params.id,
          cid: this.$route.params.cid,
          bid: 0,
          iid: 0,
          bot: 0
        }
      });
    },
    navopen(box) {
      this.$router.push({
        name: "lmsLessonView",
        params: {
          id: this.$route.params.id,
          cid: this.$route.params.cid,
          bid: box.id,
          iid: 0,
          bot: box.ot
        }
      });
    },
    subNavOpen(box, t) {
      if (box.ot != 127) {
        this.$router.push({
          name: "lmsLessonView",
          params: {
            id: this.$route.params.id,
            cid: this.$route.params.cid,
            bid: box.id,
            iid: t == undefined ? 0 : t.id,
            bot: box.ot
          }
        });
      } else {
        t != undefined
          ? window.open(t.taskDesc, "_blank")
          : this.$router.push({
              name: "lmsLessonView",
              params: {
                id: this.$route.params.id,
                cid: this.$route.params.cid,
                bid: box.id,
                iid: 0,
                bot: box.ot
              }
            });
        //console.log(t);
      }
      //&& this.lesson==undefined
      // if(box.ot==114){
      //   console.log('hicheel  rvv yavdaa');
      //   this.$router.push({name: 'lmsLessonView',
      //     params: {
      //       id: t.id,
      //       cid: this.$route.params.id,
      //       bid: 0,
      //       iid: 0
      //     }
      //   })
      // } else this.$emit("sub-nav-change", {boxId: box.id, itemId: t.id  } );
    },
    getSize(size) {
      return getSize(size);
    },
    getFileIcon(ex) {
      return getFileIcon(ex.e);
    },
    // getFileIcon(a){
    //   let rv='';
    //   if(a.isCompleted){
    //     rv='check-square';
    //   }else{
    //     switch(a.e){
    //       case 'jpg':
    //       case 'jpeg':
    //       case 'png':
    //       case 'gif':
    //         rv='image'; break;
    //       case 'mp4': rv='video'; break;
    //       case 'doc':
    //       case 'docx':
    //       case 'xls':
    //       case 'xlsx':
    //       case 'ppt':
    //       case 'pptx':
    //         rv='file'; break;
    //       case 'txt':
    //       case 'pdf':
    //         rv='file-text'; break;
    //       case 'mp3':
    //         rv='headphones'; break;
    //       default: rv='menu'; break;
    //     }
    //   }

    //   return rv;
    //   //return 'fa-file-'+getFileIcon(a.e);
    // },
    getTaskIcon(b, t) {
      let rv = "info";
      // if(b.ot==122){
      //   if(t.isCompleted){
      //     rv='check'
      //   }else{
      //     rv='play';
      //   }
      // }
      if (t.isCompleted) {
        rv = "check-square";
      } else {
        if (b.ot == 122) {
          rv = "youtube";
        } else rv = "info";
      }
      return rv;
    },
    getTaskIconBg(b, t) {
      let rv = "bd-gray-900 bg-transparent";
      //if(b.ot==122){
      if (t.isCompleted) {
        rv = "bd-success bg-success";
      }
      //}
      return rv;
    },
    getTextColor(a) {
      //console.log(ex);
      let rv = a;
      rv = "inherit";
      // switch(ex){
      //   case 'ppt':
      //   case 'pptx': rv='orange'; break;
      //   case 'png':
      //   case 'jpg':
      //   case 'jpeg':
      //   case 'bmp':
      //     rv='indigo'; break;
      //   case 'xls':
      //   case 'xlsx':
      //     rv='success'; break;
      //   case 'doc':
      //   case 'docx':
      //     rv='primary'; break;
      //   case 'mp4':
      //   case '3gp':
      //     rv='pink'; break;
      //   default: break;
      // }
      return rv;
    },
    calcaulateProgress(f) {
      let rv = 0;
      rv = (f.fillingCount * 100) / f.qCount;
      return rv;
    },
    calcaulateProgressBg(f) {
      let rv = "secondary";
      let perc = (f.fillingCount * 100) / f.qCount;

      if (perc <= 9) {
        rv = "warning";
      } else if (perc <= 19) {
        rv = "gray-200";
      } else if (perc <= 29) {
        rv = "gray-300";
      } else if (perc <= 39) {
        rv = "gray-400";
      } else if (perc <= 49) {
        rv = "gray-500";
      } else if (perc <= 59) {
        rv = "gray-600";
      } else if (perc <= 69) {
        rv = "gray-700";
      } else if (perc <= 79) {
        rv = "gray-800";
      } else if (perc <= 89) {
        rv = "gray-900";
      } else if (perc <= 99) {
        rv = "gray-900";
      } else if (perc == 100) {
        rv = "success";
      }
      return rv;
    }
  }
};
</script>

<style></style>
